import * as React from 'react';
function SvgCustomExpand(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentcolor"
      className="custom-expand_svg__fil-icon"
      {...props}
    >
      <path d="M21.122 9.376v-6h-5.999M20.747 3.752l-6.5 6.5M3.376 15.12v6h5.999M10.249 14.248l-6.5 6.5" />
    </svg>
  );
}
export default SvgCustomExpand;
